module.exports = __webpack_public_path__ + "media/flags/mp-4b173ce7.svg";